import {
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  Max,
  Min,
  MaxLength,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { Transform } from 'class-transformer'
import {
  MAX_CLASS_NAME_LENGTH,
  MIN_MAX_STUDENTS,
  MAX_MAX_STUDENTS,
} from '../../../constants/class.constants'

const toNumber = ({ value }: { value: any }) => {
  if (value === '' || value === null || value === undefined) return undefined
  return Number(value)
}

export class CreateClassDto {
  @ApiProperty({
    description: 'Nom de la classe',
    example: '6ème A',
    maxLength: MAX_CLASS_NAME_LENGTH,
    type: 'string',
  })
  @IsNotEmpty({ message: 'Le nom de la classe est requis' })
  @IsString()
  @MaxLength(MAX_CLASS_NAME_LENGTH)
  name!: string

  @ApiProperty({
    description: "ID de l'établissement",
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty({ message: "L'établissement est requis" })
  @IsUUID('4')
  establishmentId!: string

  @ApiProperty({
    description: 'ID du niveau scolaire',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty({ message: 'Le niveau est requis' })
  @IsUUID('4')
  levelExternalId!: string

  @ApiPropertyOptional({
    description: 'ID de la section',
    example: '550e8400-e29b-41d4-a716-446655440001',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  sectionId?: string

  @ApiProperty({
    description: "ID de l'année scolaire",
    example: '550e8400-e29b-41d4-a716-446655440002',
    type: 'string',
  })
  @IsNotEmpty({ message: "L'année scolaire est requise" })
  @IsUUID('4')
  schoolYearId!: string

  @ApiProperty({
    description: 'ID du statut',
    example: '550e8400-e29b-41d4-a716-446655440003',
    type: 'string',
  })
  @IsNotEmpty({ message: 'Le statut est requis' })
  @IsUUID('4')
  statusId!: string

  @ApiProperty({
    description: "Nombre maximum d'élèves",
    example: 30,
    minimum: MIN_MAX_STUDENTS,
    maximum: MAX_MAX_STUDENTS,
    type: Number,
  })
  @IsNotEmpty({ message: "Le nombre maximum d'élèves est requis" })
  @Transform(toNumber)
  @IsNumber()
  @Min(MIN_MAX_STUDENTS)
  @Max(MAX_MAX_STUDENTS)
  maxStudents!: number

  @ApiPropertyOptional({
    description: 'IDs des élèves à ajouter',
    type: [String],
  })
  @IsOptional()
  @IsUUID('4', { each: true })
  studentIds?: string[]

  @ApiPropertyOptional({
    description: 'ID utilisateur du professeur principal',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  mainTeacherUserId?: string
}
